import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";

import "./index.css";
import "./App.css";
import "./App.phone.css";

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
